<template lang="pug">
  div
    div.row
      div.col-6(v-if="$store.state.user.user.username === 'ict' || $store.state.user.user.username === 'weian'")
        h5 匯入{{ title }}資訊
        div.form-group
          label(for="fileupload") 請選擇欲上傳的excel檔案
          input.form-control-file#fileupload(type="file" name="medtable" @change="onChange")
        button.btn.btn-primary(@click="upload") 上傳檔案
        
      div.col-6
        h5 匯出{{ title }}資訊
        div.form-group
          button(@click="download") 下載資料庫

      div.col-12
        hr
        h6(v-if="uploadProgress !== 0") 上傳中...
        div.progress(v-if="uploadProgress !== 0")
          div.progress-bar(role="progressbar" :style="{ width: `${uploadProgress}%` }" :aria-valuenow="uploadProgress" aria-valuemin="0" aria-valuemax="100")
        
        p(v-if="resultMsg.length !== 0") 上傳結果:
        p(v-for="msg in resultMsg" style="margin: 0") {{ msg }}
</template>

<script>
import server from '@/config';

export default {
  name: 'DataImportBase',
  props: ['title', 'uploadUrl', 'downloadUrl'],
  data() {
    return {
      uploadFile: '',
      uploadProgress: 0,
      resultMsg: [],
    };
  },
  computed: {
    instance() {
      return this.$store.state.instance;
    },
  },
  methods: {
    onChange(event) {
      this.uploadFile = event.target.files;
    },
    upload() {
      if (this.uploadFile !== '') {
        // if (this.uploadFile[0].type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
        this.resultMsg = [];
        const data = new FormData();
        data.append('file', this.uploadFile[0]);
        this.instance.post(this.uploadUrl, data, {
          onUploadProgress: (progressEvent) => {
            console.log('event: ', progressEvent.loaded, progressEvent.total, progressEvent.loaded / progressEvent.total);
            this.uploadProgress = (progressEvent.loaded / progressEvent.total) * 100;
          },
          timeout: 60000,
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then((res) => {
          console.log('done');
          this.uploadProgress = 0;
          this.$store.commit('SET_MESSAGE', {
            type: 'success',
            context: '更新完成',
          });
          res.data.split('->').forEach((msg) => {
            this.resultMsg.push(msg);
          });
        })
        .catch((error) => {
          let context = '';
          if (error.response) {
            context = error.response.data;
          }

          this.$store.commit('SET_MESSAGE', {
            type: 'error',
            context: `上傳失敗: ${context}`,
          });

          this.uploadProgress = 0;
        });
        // } else {
        //   this.$store.commit('SET_MESSAGE', {
        //     type: 'error',
        //     context: '請確認上傳檔案為.xlsx',
        //   });
        // }
      } else {
        this.$store.commit('SET_MESSAGE', {
          type: 'error',
          context: '請先選擇上傳檔案',
        });
      }
    },
    download() {
      window.open(`${server}${this.downloadUrl}`, '_blank');
    },
  },
};
</script>

<style lang="sass">

</style>




// WEBPACK FOOTER //
// DataImportBase.vue?276bff93